export default function FAQSection() {
  const faqs = [
    {
      q: 'What is a Hipobuy spreadsheet?',
      a: 'A Hipobuy spreadsheet is a curated, organized document that compiles product information from the Hipobuy platform, including product names, prices, QC photo links, seller names, size charts, and direct purchase links — all arranged in an easy-to-browse format.',
    },
    {
      q: 'Are Hipobuy spreadsheets free to use?',
      a: 'Yes, most Hipobuy spreadsheets are shared freely within the community. The value comes from the curation and organization done by experienced shoppers who compile and maintain these resources for everyone to benefit from.',
    },
    {
      q: 'How often are Hipobuy spreadsheets updated?',
      a: 'The best Hipobuy spreadsheets are updated regularly — some weekly, others monthly. Always check the last update date and use the most current version to ensure active product links and accurate pricing information.',
    },
    {
      q: 'Can beginners use Hipobuy spreadsheets effectively?',
      a: 'Absolutely. Hipobuy spreadsheets are designed to make shopping easier for everyone. Beginners benefit even more because the spreadsheet eliminates the learning curve of navigating the platform and evaluating sellers.',
    },
    {
      q: 'What is the most important column in a Hipobuy spreadsheet?',
      a: 'The QC (Quality Control) photo column is the most valuable. Being able to see actual photos of the product before purchasing is the single most important feature and the biggest advantage over traditional browsing.',
    },
    {
      q: 'How do I access the Hipobuy spreadsheet database?',
      a: 'You can access the complete Hipobuy spreadsheet database by visiting the main platform at kaspreadsheet.com, where you will find organized categories, direct product links, and regularly updated product information.',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="text-xs font-semibold text-foreground-500 uppercase tracking-widest mb-3">
            &bull; FAQ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.15]">
            Frequently Asked Questions
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto leading-relaxed">
            Everything you need to know about Hipobuy spreadsheets, how they work, and how to get started.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between gap-4 px-6 py-5 text-base font-semibold text-foreground-950 list-none">
                {faq.q}
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-lg"></i>
                </div>
              </summary>
              <div className="px-6 pb-5 text-sm text-foreground-600 leading-relaxed">
                {faq.a}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}